Ext.define('SA.HistogramParts', {
    statics: {
        get({cfg, frameSize, data}) {
            var parts = new SA.HistogramParts({cfg, frameSize, data});

            return {
                chartTitle: parts.getChartTitle(),
                xAxisTitle: parts.getXTitle(),
                yAxisTitle: parts.getYTitle(),
                frame: parts.getFrameRect(),
                bars: parts.getBars(),
                gridLines: parts.getGridLines(),
                xLabels: parts.getXLabels(),
                yLabels: parts.getYLabels()
            };
        }
    },

    constructor({cfg, frameSize, data}) {
        this.cfg = cfg;
        this.frameSize = frameSize;
        this.data = data;

        this.yScale = new SA.HistogramYScale({maxCount: data.getMaxCount(), frameSize});
        this.xScale = new SA.HistogramXScale({ticks: data.getIntervalEdges(), frameSize, tickLabelFormatter: cfg.text.xAxisTickLabelFormatter});
    },

    getBars() {
        var count = this.data.getIntervalCount(),
            barWidth = (this.frameSize.width - (this.cfg.bar.gap * count)) / count;

        return {
            type: 'g',

            content: this.data.mapBins(({count, interval}) => ({
                type: 'rect',
                height: this.yScale.getBarHeightForCount(count),
                width: barWidth,
                x: this.xScale.getXForValue(interval[0]) + (this.cfg.bar.gap / 2),
                y: this.yScale.getYForCount(count),
                style: {fill: this.cfg.bar.color}
            }))
        };
    },

    getChartTitle() {
        var text = this.cfg.text.chartTitle,
            maxWidth = this.cfg.layout.titleMaxWidth,
            style = SA.HistogramPartStyles.get('chartTitle');

        return SA.BalancedChartText.get({text, maxWidth, ...style});
    },

    getFrameRect() {
        var style = SA.HistogramPartStyles.get('frame');

        return {type: 'rect', style, ...this.frameSize};
    },

    getGridLines() {
        return {
            type: 'g',

            content: this.yScale.mapTicks(({y}) => ({
                type: 'line',
                x1: 0,
                x2: this.frameSize.width,
                y1: y,
                y2: y,
                style: SA.HistogramPartStyles.get('gridLine')
            }))
        };
    },

    getXLabels() {
        var y = this.frameSize.height + this.cfg.layout.axisLabelOffset;

        return {
            type: 'g',

            content: this.xScale.mapTicks(({x, label}) => ({
                type: 'text',
                content: label,
                transform: `rotate(-45 ${x} ${y})`,
                style: SA.HistogramPartStyles.get('xLabel'),
                x, y
            }))
        };
    },

    getXTitle() {
        var text = this.cfg.text.xTitle,
            maxWidth = this.cfg.layout.titleMaxWidth,
            style = SA.HistogramPartStyles.get('xTitle');

        return SA.BalancedChartText.get({text, maxWidth, ...style});
    },

    getYLabels() {
        var x = 0 - this.cfg.layout.axisLabelOffset;

        return {
            type: 'g',

            content: this.yScale.mapTicks(({y, label}) => ({
                type: 'text',
                content: label,
                style: SA.HistogramPartStyles.get('yLabel'),
                x, y
            }))
        };
    },

    getYTitle() {
        return {
            type: 'text',
            content: this.cfg.text.yTitle,
            transform: 'rotate(-90)',
            style: SA.HistogramPartStyles.get('yTitle')
        };
    }
});